import React from 'react';

/**
 * A small square holding an icon. Neutral by default; a tone tints it to carry
 * state (accent = needs you, warn = needs action, bad = rejected, ok = approved).
 */
const IconTile = ({ icon, tone, size }) => (
  <span className={`do-ico${tone ? ` do-ico--${tone}` : ''}${size === 'lg' ? ' do-ico--lg' : ''}`} aria-hidden="true">
    {icon}
  </span>
);

export default IconTile;
